import { createContext } from 'react';

interface ViewerContextType {
    viewer: Cesium.Viewer | null;
    setViewerRef: (node: HTMLDivElement | null) => void;
}

export const ViewerContext = createContext<ViewerContextType | null>(null);
